import { useParams, Link } from "react-router-dom"
import Header from "../../../components/forms/Header"
import ConfirmAccountDeletion from "../../../components/deleteAccount/ConfirmAccountDeletion"
import { usePublicSiteBranding } from "../../../contexts/PublicSiteContext"

export default function ConfirmDeleteAccountPage() {
  const { token } = useParams<{ token: string }>()
  const branding = usePublicSiteBranding()

  if (!token) {
    return (
      <section className="flex pt-6 md:items-center md:pb-44 justify-center md:w-full md:min-h-screen">
        <div className="md:w-2/4 lg:max-w-xl md:p-5 md:shadow-xl md:rounded-xl bg-white text-center">
          <p className="text-sm text-gray-600">Invalid confirmation link.</p>
          <Link to="/deleteAccount" className="text-primary hover:underline mt-4 inline-block">
            Request account deletion
          </Link>
        </div>
      </section>
    )
  }

  return (
    <section
      className={`flex pt-6 md:pt-none md:items-center md:pb-44 justify-center md:w-full ${branding.authPageMdGradientClass}`}
    >
      <div className="md:w-2/4 lg:max-w-xl md:p-5 md:shadow-xl md:rounded-xl bg-white">
        <Header heading="Confirm account deletion" paragraph="" linkName="" linkUrl="" />
        <ConfirmAccountDeletion token={token} />
      </div>
    </section>
  )
}
